const PLAYBACK_RATE_KEY = "player_playback_rate";

export const PLAYBACK_RATE_VARIANTS = [1, 1.5, 2];

export const getSavedPlaybackRate = () => {
  try {
    const saved = localStorage.getItem(PLAYBACK_RATE_KEY);
    return PLAYBACK_RATE_VARIANTS.includes(saved) ? saved : 1;
  } catch (e) {
    return 1;
  }
};

export const savePlaybackRate = (rate) => {
  localStorage.setItem(PLAYBACK_RATE_KEY, rate.toString());
};
